module.exports = __webpack_public_path__ + "resources/com-status-network-fail.9b009a421f6221d4.png";